export const WEEKDAY_OPTIONS = [
    { label: "Пн", value: 1 },
    { label: "Вт", value: 2 },
    { label: "Ср", value: 3 },
    { label: "Чт", value: 4 },
    { label: "Пт", value: 5 },
    { label: "Сб", value: 6 },
    { label: "Нд", value: 7 },
];

export const WEEKDAY_OPTIONS_WITH_ALL = [
    { label: "Всі", value: 0 },
    ...WEEKDAY_OPTIONS,
];
